// src/main.tsx


let APP_INITIALIZED = false;
//import "../consoleDisabler.js";
import './env-polyfill'; // Must be imported before any other components
import './index.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../invite-system/src/contexts/AuthContext';


// Import panel system providers
import { PanelProvider } from './components/PanelSystem/PanelContext';
import { TransitionConfigProvider } from './components/PanelSystem/TransitionConfigContext';
import { TransitionOrchestratorProvider } from './components/PanelSystem/TransitionOrchestratorContext';


// Add to your app's entry point (index.js or App.js)
if (process.env.NODE_ENV === 'production' || window.location.search.includes('noconsole')) {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.info = noop;
  console.debug = noop;
  // Keep console.error to see actual errors
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  //<React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        {/* Proper provider nesting order - PanelProvider must be first */}
        <PanelProvider>
          <TransitionConfigProvider>
            <TransitionOrchestratorProvider>
              <App />
            </TransitionOrchestratorProvider>
          </TransitionConfigProvider>
        </PanelProvider>
      </AuthProvider>
    </BrowserRouter>
  //</React.StrictMode>
);